<template>
  <section class="dashboard">
    <div class="page-header">
      <h3 class="page-title">Standorte</h3>
    </div>

    <div class="row">
      <div class="col-12 grid-margin">
        <div v-if="loading" class="loading-container">
          <i class="fa fa-cog fa-spin"></i>
          <span>Daten werden geladen...</span>
        </div>
        <div class="card" v-if="!loading">
          <div class="card-body">
            <h4 class="card-title">Einrichtungen ({{ locations.length }})</h4>
            <b-form-select v-model="stateFilter" :options="account_states"
              style="margin-bottom: 20px" />

            <form class="forms-sample">
              <b-form-group label="" label-for="input1">
                <b-form-input v-model="invoicefilter" type="text" id="input1"
                  placeholder="Kategorie oder Einrichtung..."></b-form-input>
              </b-form-group>

              <div class="preset-row">
                <span class="preset-label">Arbeitslisten</span>
                <b-button v-for="preset in presets" :key="preset.key" size="sm"
                  :variant="activePreset === preset.key ? 'info' : 'outline-info'"
                  v-title="preset.hint" @click="applyPreset(preset.key)">
                  {{ preset.label }}
                </b-button>
              </div>

              <div class="filter-chips">
                <b-button v-for="chip in chips" :key="chip.key" size="sm"
                  :variant="chipVariant(chip.key)" v-title="chip.hint" @click="cycleChip(chip.key)">
                  {{ chipLabel(chip) }}
                </b-button>
                <b-form-select size="sm" v-model="tagFilter" :options="availableTags" class="tag-select"></b-form-select>
                <b-button v-if="activeFilterCount > 0" size="sm" variant="outline-danger" @click="resetFilters">
                  <i class="fa fa-times"></i> Filter zurücksetzen ({{ activeFilterCount }})
                </b-button>
              </div>

              <!-- Was ein aktiver Chip wirklich misst. Steht hier statt im Tooltip,
                   weil vuejs-title auf 250x50 Pixel deckelt und laengere Texte
                   stillschweigend abschneidet. -->
              <div v-if="activeChipNotes.length > 0" class="chip-notes">
                <p v-for="note in activeChipNotes" :key="note.key" class="chip-note">
                  <strong>{{ note.label }}:</strong> {{ note.text }}
                </p>
              </div>
            </form>
            <div v-title="'Somethings...'"></div>
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th class="sortable-th" @click="sortBy('category')">Kategorie <i :class="sortIcon('category')"></i></th>
                    <th class="sortable-th" @click="sortBy('created_at')">Erstellt <i :class="sortIcon('created_at')"></i></th>
                    <th class="sortable-th" @click="sortBy('name')">Einrichtung <i :class="sortIcon('name')"></i></th>
                    <th class="sortable-th" @click="sortBy('next_settlement_stamp')">Nächste Abrechnung <i :class="sortIcon('next_settlement_stamp')"></i></th>
                    <th class="sortable-th" @click="sortBy('billings_count')">Rechnungen <i :class="sortIcon('billings_count')"></i></th>
                    <th>Abrechnung</th>
                    <th class="sortable-th" @click="sortBy('notice')">Notiz <i :class="sortIcon('notice')"></i></th>
                    <th class="sortable-th" @click="sortBy('billing_sepa')">SEPA <i :class="sortIcon('billing_sepa')"></i></th>
                    <th class="sortable-th" @click="sortBy('flutter_adopted_sort')">Flutter <i :class="sortIcon('flutter_adopted_sort')"></i></th>
                    <th class="sortable-th" @click="sortBy('account_tags_sort')">Tags <i :class="sortIcon('account_tags_sort')"></i></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in sortedLocations" :key="item.uid">
                    <td>
                      <a class="link-col" :href="generateLink(item.uid)" target="_blank">{{ item.category }}</a>
                    </td>
                    <td>
                      {{ item.created_at | moment(" D.MM.YYYY") }}
                    </td>
                    <td>
                      <a class="link-col" :href="generateLink(item.uid)" target="_blank">{{ item.name }}</a>
                    </td>
                    <td>
                      {{ item.next_settlement }}
                    </td>
                    <td>
                      {{ item.billings_count }}

                      ({{ item.unpaid_invoices }})
                      <i v-if="item.billing_alert && item.billing_alert == 'y'" class="fa fa-check"
                        style="margin-left: 5px" aria-hidden="true"></i>
                    </td>
                    <td>
                      <i v-if="item.billing_check && item.billing_check.status === 'over'"
                        class="mdi mdi-24px mdi-circle text-danger" style="cursor: help;"
                        v-title="billingCheckTooltip(item)"></i>
                    </td>
                    <td>
                      <div v-if="item.notice && item.notice.length > 1" v-title="item.notice"><i
                          class="mdi  mdi-24px  mdi-clipboard-alert text-info" style="cursor:pointer;" /></div>
                    </td>
                    <td>
                      <i v-if="item.billing_sepa && item.billing_sepa == 'y'" class="fa fa-check"
                        style="margin-left: 5px" aria-hidden="true"></i>
                    </td>
                    <td>
                      <i v-if="item.flutter_app_first_seen_at" class="fa fa-check"
                        style="margin-left: 5px" aria-hidden="true"
                        v-title="flutterTooltip(item)"></i>
                    </td>
                    <td>
                      <div v-for="item_account in item.account_tags" :key="item_account" class="badge-container">
                        <span class="badge-tag">{{ item_account }}</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-if="sortedLocations && sortedLocations.length === 0" class="empty-state">
                <i class="mdi mdi-filter-remove-outline"></i>
                <p>Keine Einrichtungen für diese Filter gefunden.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { getAll } from "@/services/locations.service";
import { settlementState } from "@/utils/settlement";

// ---------------------------------------------------------------------------
// Filter mit drei Zustaenden
//
// Ein Chip steht auf null (aus), "ja", "nein" oder "unbekannt". Gefiltert wird
// auf Gleichheit mit dem Zustand, den state() fuer die Zeile liefert.
//
// Warum "unbekannt" ein eigener Zustand ist und nicht stillschweigend als
// "nein" durchgeht: sonst traegt ein fehlender Wert eine positive Aussage.
// Eine Einrichtung ohne hinterlegtes Abrechnungsdatum ist nicht "nicht
// faellig" — wir wissen es schlicht nicht. Zeilen im Zustand "unbekannt"
// fallen deshalb aus BEIDEN Richtungen heraus und sind nur ueber den eigenen
// Chip-Zustand zu sehen. hasUnknown sagt, ob der Zustand beim Durchklicken
// angeboten wird; er wird nur dort angeboten, wo er wirklich vorkommen kann.
// ---------------------------------------------------------------------------

// hint = Kurztext fuer den Tooltip. vuejs-title deckelt sein Bauteil auf
// 250x50 Pixel mit overflow:hidden (node_modules/vuejs-title/dist/vuejs-title.esm.js,
// conf.maxWidth/maxHeight), also ZWEI Zeilen (gemessen 23.09.2026, 14px
// Ubuntu, word-break:break-all). Alles Laengere wird
// stillschweigend abgeschnitten. Was der Mensch wirklich lesen muss, steht
// deshalb in note und wird unter der Chip-Reihe ANGEZEIGT, sobald der Chip
// aktiv ist, statt in einem Tooltip zu verschwinden.
const CHIP_FILTERS = [
  {
    key: 'sepa',
    hasUnknown: false,
    labels: { aus: 'SEPA', ja: 'SEPA', nein: 'ohne SEPA' },
    hint: 'Kennzeichen „SEPA-Lastschriftmandat" im Stammblatt.',
    // note gilt in JEDEM Zustand, noteNein nur im Zustand 'nein'. Der
    // Zusammenfassungs-Satz gehoert dorthin: wer auf vorhandenes SEPA filtert,
    // liest sonst eine Erklaerung ueber die Gegenmenge.
    note:
      'Gemessen wird das Kennzeichen „SEPA-Lastschriftmandat" im Stammblatt, nicht ' +
      'das Mandat selbst. Ob ein vollständiges Mandat vorliegt, entscheidet an ' +
      'anderer Stelle die Kombination aus sepa, iban und sepa_mandate_date; beide ' +
      'können auseinanderlaufen.',
    noteNein:
      'Bewusst zusammengefasst: nie gepflegt und ausdrücklich „nein" zählen beide ' +
      'als „ohne SEPA", weil für beide dasselbe zu tun ist.',
    // Zusammenfassen ist hier eine ENTSCHEIDUNG, keine Messung: reload() walzt
    // jeden Nicht-'y'-Wert auf 'n', bevor dieser Zustand gelesen wird. Wer die
    // Fälle je trennen will, muss zuerst dort aufhören zu normalisieren.
    state: function (item) {
      return item.billing_sepa === 'y' ? 'ja' : 'nein';
    },
  },
  {
    key: 'settlement',
    hasUnknown: true,
    labels: {
      aus: 'Abr. fällig',
      ja: 'Abr. fällig',
      nein: 'nicht fällig',
      unbekannt: 'kein verwertbares Datum',
    },
    hint: 'Nächstes Abrechnungsdatum heute oder früher.',
    note:
      'Gemessen wird „Nächste Abrechnung" aus dem Stammblatt, ein Textdatum im ' +
      'Format TT.MM.JJJJ.',
    noteUnknown:
      '„kein verwertbares Datum" sammelt vier Fälle: gar kein Stammblatt (das Feld ' +
      'steht dann auf „-"), kein Datum hinterlegt, unlesbares Format, und ein Datum, ' +
      'das es nicht gibt (etwa 31.02.). Nicht jeder dieser Fälle ist harmlos: ein ' +
      'zweistelliges Jahr lesen wir hier als unverwertbar, der Server ergänzt es ' +
      'dagegen (00 bis 68 werden zu 20xx, 69 bis 99 zu 19xx). Aus 01.02.26 wird dort ' +
      'also 2026 und würde abgerechnet, aus 01.02.27 wird 2027 und nicht. Diese ' +
      'Zeilen ansehen, nicht nur wegfiltern.',
    state: settlementState,
  },
  {
    key: 'overdue',
    hasUnknown: true,
    labels: { aus: 'Überfällig', ja: 'Überfällig', nein: 'nicht überfällig', unbekannt: 'nie gezählt' },
    hint: 'Unbezahlt und Zahlungsziel (30 Tage ab Rechnungsdatum) abgelaufen.',
    note:
      '„Überfällig" liest das Feld unpaid_invoices. Es zählt nur Rechnungen, die ' +
      'unbezahlt sind und deren Zahlungsziel abgelaufen ist: 30 Tage ab Rechnungsdatum, ' +
      'ohne lesbares Rechnungsdatum ab Anlage. Frisch gestellte und entfernte ' +
      'Rechnungen zählen nicht mit, stornierte nur dann nicht, wenn die Stornierung ' +
      'an der Rechnung vermerkt ist; ältere Stornos erst nach dem Nachtrag. Der Wert ist ein Schnappschuss der letzten Zählung, kein Live-Wert: ' +
      'geschrieben wird er ausschließlich vom Aufruf /count-unpaid-invoices, den kein ' +
      'Repo aufruft. Wie alt die Zahl ist, entscheidet ein Cron auf dem Server.',
    noteUnknown:
      '„nie gezählt" heißt, dass zu dieser Einrichtung noch nie ein Wert geschrieben ' +
      'wurde. Das ist etwas anderes als „keine offenen Rechnungen".',
    state: function (item) {
      if (item.unpaid_invoices === null || item.unpaid_invoices === undefined) {
        return 'unbekannt';
      }
      return item.unpaid_invoices > 0 ? 'ja' : 'nein';
    },
  },
  {
    key: 'billings',
    hasUnknown: false,
    labels: { aus: 'Rechnung vorhanden', ja: 'Rechnung vorhanden', nein: 'noch keine Rechnung' },
    hint: 'Ob überhaupt schon eine Rechnung existiert.',
    note: '',
    // billings_count wird je Anfrage frisch gezaehlt und ist immer eine Zahl.
    // Der unbekannt-Zweig ist trotzdem da: kommt doch etwas anderes an, faellt
    // die Zeile aus beiden Richtungen heraus, statt falsch einsortiert zu werden.
    state: function (item) {
      if (typeof item.billings_count !== 'number') return 'unbekannt';
      return item.billings_count > 0 ? 'ja' : 'nein';
    },
  },
  {
    key: 'notice',
    hasUnknown: false,
    labels: { aus: 'Anmerkung', ja: 'Anmerkung', nein: 'ohne Anmerkung' },
    hint: 'Ob eine interne Anmerkung hinterlegt ist.',
    note: '',
    // Dieselbe Schwelle wie die Notiz-Spalte der Tabelle (v-if length > 1),
    // damit Chip und Symbol nicht gegensätzlich urteilen.
    state: function (item) {
      return item.notice && item.notice.length > 1 ? 'ja' : 'nein';
    },
  },
];

// Arbeitslisten setzen die Chips SICHTBAR, statt einen eigenen versteckten
// Modus zu fuehren. Danach laesst sich jeder Chip einzeln nachjustieren.
const FILTER_PRESETS = [
  {
    key: 'abrechnen',
    label: 'Heute abzurechnen',
    hint: 'Kunden, deren nächstes Abrechnungsdatum erreicht ist.',
    account_state: 'customer',
    chips: { settlement: 'ja' },
  },
  {
    key: 'mahnen',
    label: 'Mahnen',
    hint: 'Kunden mit unbezahlter Rechnung, deren Zahlungsziel abgelaufen ist.',
    account_state: 'customer',
    chips: { overdue: 'ja' },
  },
  {
    key: 'ohne-sepa',
    label: 'Ohne SEPA',
    hint: 'Kunden ohne gesetztes Kennzeichen „SEPA-Lastschriftmandat".',
    account_state: 'customer',
    chips: { sepa: 'nein' },
  },
  {
    key: 'neu-ohne-rechnung',
    label: 'Neu, noch ohne Rechnung',
    hint: 'Kunden, zu denen noch nie eine Rechnung erzeugt wurde.',
    account_state: 'customer',
    chips: { billings: 'nein' },
  },
  {
    key: 'ohne-datum',
    label: 'Ohne verwertbares Datum',
    hint: 'Kunden, deren Abrechnungsdatum fehlt oder unlesbar ist.',
    account_state: 'customer',
    chips: { settlement: 'unbekannt' },
  },
];

export default {
  name: "dashboard",
  components: {},
  data() {
    return {
      stateFilter: "customer",
      loading: true,
      // Ein Eintrag je Chip: null | 'ja' | 'nein' | 'unbekannt'.
      // Alle Schluessel werden hier angelegt, damit Vue 2 sie beobachtet.
      chipState: {
        sepa: null,
        settlement: null,
        overdue: null,
        billings: null,
        notice: null,
      },
      activePreset: null,
      tagFilter: null,
      invoicefilter: null,
      sortKey: 'name',
      sortOrder: 'asc',
      account_states: [
        { text: "Test", value: "test" },
        { text: "Kunde", value: "customer" },
        { text: "Kostenlose Nutzung", value: "forfree" },
        { text: "Geschlossen", value: "close" },

      ],
    };
  },
  computed: {
    sortedLocations: function () {
      let locations = this.locations;

      if (this.sortKey) {
        locations = locations.slice().sort((a, b) => {
          let valA = a[this.sortKey];
          let valB = b[this.sortKey];

          if (valA == null) valA = '';
          if (valB == null) valB = '';

          if (typeof valA === 'string' && typeof valB === 'string') {
            valA = valA.toLowerCase();
            valB = valB.toLowerCase();
          }

          if (this.sortOrder === 'asc') {
            return valA > valB ? 1 : valA < valB ? -1 : 0;
          } else {
            return valA < valB ? 1 : valA > valB ? -1 : 0;
          }
        });
      }

      return locations;
    },
    availableTags: function () {
      var tags = [{ text: 'Alle Tags', value: null }];
      if (!this.$store.state.locations) return tags;

      var seen = {};
      for (var i = 0; i < this.$store.state.locations.length; i++) {
        var loc = this.$store.state.locations[i];
        if (loc.account_tags && loc.account_tags.length) {
          for (var j = 0; j < loc.account_tags.length; j++) {
            var tag = loc.account_tags[j];
            if (!seen[tag]) {
              seen[tag] = true;
              tags.push({ text: tag, value: tag });
            }
          }
        }
      }
      return tags;
    },
    locations: function () {
      // Leere Liste statt undefined: sortedLocations liest
      // hier weiter, bevor der erste Ladevorgang durch ist.
      if (!this.$store.state.locations) {
        return [];
      }

      var self = this;

      return this.$store.state.locations.filter(function (item) {
        if (item.account_state != self.stateFilter) return false;

        if (self.invoicefilter) {
          var needle = self.invoicefilter.toLowerCase();
          var inCategory =
            item.category &&
            item.category.toString().toLowerCase().indexOf(needle) !== -1;
          var inName =
            item.name && item.name.toString().toLowerCase().indexOf(needle) !== -1;

          if (!inCategory && !inName) return false;
        }

        if (self.tagFilter) {
          if (!item.account_tags || item.account_tags.indexOf(self.tagFilter) === -1) {
            return false;
          }
        }

        // Ein aktiver Chip verlangt Gleichheit mit seinem Zustand. Eine Zeile im
        // Zustand 'unbekannt' trifft damit weder 'ja' noch 'nein' und faellt aus
        // beiden Richtungen heraus, statt stillschweigend als 'nein' zu zaehlen.
        for (var i = 0; i < CHIP_FILTERS.length; i++) {
          var chip = CHIP_FILTERS[i];
          var wanted = self.chipState[chip.key];

          if (!wanted) continue;
          if (chip.state(item) !== wanted) return false;
        }

        return true;
      });
    },
    chips: function () {
      return CHIP_FILTERS;
    },
    activeChipNotes: function () {
      var self = this;
      var notes = [];

      for (var i = 0; i < CHIP_FILTERS.length; i++) {
        var chip = CHIP_FILTERS[i];
        var state = self.chipState[chip.key];

        if (!state) continue;

        // note gilt in jedem Zustand des Chips; noteNein und noteUnknown NUR in
        // ihrem eigenen Zustand. Sonst steht unter einem Chip, der auf 'ja'
        // steht, eine Erklaerung fuer einen Zustand, den er gerade nicht hat.
        var text = chip.note || '';
        var zusatz = null;

        if (state === 'nein' && chip.noteNein) zusatz = chip.noteNein;
        if (state === 'unbekannt' && chip.noteUnknown) zusatz = chip.noteUnknown;

        if (zusatz) {
          text = text ? text + ' ' + zusatz : zusatz;
        }

        if (!text) continue;

        notes.push({
          key: chip.key,
          label: self.chipLabel(chip),
          text: text,
        });
      }

      return notes;
    },
    presets: function () {
      return FILTER_PRESETS;
    },
    activeFilterCount: function () {
      var count = 0;

      for (var i = 0; i < CHIP_FILTERS.length; i++) {
        if (this.chipState[CHIP_FILTERS[i].key]) count++;
      }

      if (this.tagFilter) count++;
      if (this.invoicefilter) count++;

      return count;
    },
  },
  methods: {
    sortIcon: function (key) {
      if (this.sortKey !== key) return 'fa fa-sort sort-icon sort-icon-inactive';
      return this.sortOrder === 'asc' ? 'fa fa-sort-asc sort-icon' : 'fa fa-sort-desc sort-icon';
    },
    chipByKey: function (key) {
      for (var i = 0; i < CHIP_FILTERS.length; i++) {
        if (CHIP_FILTERS[i].key === key) return CHIP_FILTERS[i];
      }
      return null;
    },
    chipLabel: function (chip) {
      var state = this.chipState[chip.key];

      if (!state) return chip.labels.aus;

      // Fehlt eine Beschriftung fuer den Zustand, steht der Zustand selbst da,
      // statt "undefined" auf dem Knopf.
      return chip.labels[state] || chip.labels.aus + ': ' + state;
    },
    chipVariant: function (key) {
      var state = this.chipState[key];

      if (state === 'ja') return 'primary';
      if (state === 'nein') return 'dark';
      if (state === 'unbekannt') return 'warning';

      return 'outline-secondary';
    },
    cycleChip: function (key) {
      var chip = this.chipByKey(key);
      if (!chip) return;

      var order = chip.hasUnknown
        ? [null, 'ja', 'nein', 'unbekannt']
        : [null, 'ja', 'nein'];

      var current = this.chipState[key] || null;
      var next = order[(order.indexOf(current) + 1) % order.length];

      this.$set(this.chipState, key, next);

      // Von Hand gedreht heisst: das ist keine Arbeitsliste mehr.
      this.activePreset = null;
    },
    clearChips: function () {
      for (var i = 0; i < CHIP_FILTERS.length; i++) {
        this.$set(this.chipState, CHIP_FILTERS[i].key, null);
      }
    },
    applyPreset: function (key) {
      var preset = null;

      for (var i = 0; i < FILTER_PRESETS.length; i++) {
        if (FILTER_PRESETS[i].key === key) preset = FILTER_PRESETS[i];
      }

      if (!preset) return;

      // Ein zweiter Klick auf dieselbe Arbeitsliste schaltet sie wieder aus.
      if (this.activePreset === key) {
        this.resetFilters();
        return;
      }

      this.clearChips();

      // Suche und Tag mit abraeumen: eine Arbeitsliste soll die ganze Menge
      // zeigen. Bliebe eine Suche stehen, waere die Liste eine stille Teilmenge.
      this.tagFilter = null;
      this.invoicefilter = null;

      for (var k = 0; k < CHIP_FILTERS.length; k++) {
        var chipKey = CHIP_FILTERS[k].key;
        if (preset.chips[chipKey]) {
          this.$set(this.chipState, chipKey, preset.chips[chipKey]);
        }
      }

      if (preset.account_state) this.stateFilter = preset.account_state;

      this.activePreset = key;
    },
    resetFilters: function () {
      this.clearChips();
      this.tagFilter = null;
      this.invoicefilter = null;
      this.activePreset = null;
    },
    sortBy: function (key) {
      if (this.sortKey === key) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortKey = key;
        this.sortOrder = 'asc';
      }
    },
    // Indikator erscheint NUR bei Unterlizenzierung (status 'over':
    // mehr aktive Kinder als abgerechnet). ok/under/unknown werden
    // bewusst nicht angezeigt.
    billingCheckTooltip: function (item) {
      var bc = item.billing_check;
      if (!bc) return '';
      return 'aktiv ' + bc.childs_count + ' / abgerechnet ' + bc.billed_childs +
        ' (mehr aktive als abgerechnete Kinder)';
    },
    flutterTooltip: function (item) {
      if (!item.flutter_app_first_seen_at) return 'Flutter-App noch nicht im Einsatz';
      var parts = [];
      if (item.flutter_app_last_seen_at) {
        parts.push('Zuletzt aktiv ' + this.moment(item.flutter_app_last_seen_at).format(' D.MM.YYYY hh:mm'));
      }
      if (item.flutter_app_version) {
        parts.push('Version ' + item.flutter_app_version);
      }
      return parts.length ? parts.join(' · ') : 'Flutter-App im Einsatz';
    },
    generateLink(uid) {
      return this.$router.resolve({
        name: 'location-detail',
        params: { uid }
      }).href;
    },
    reload: function () {
      var self = this;

      this.loading = true;

      getAll().then((resp) => {
        self.loading = false;

        if (resp.data.error) {
          localStorage.removeItem("token");
          self.$router.push({ name: "login" });
        } else {
          self.$store.state.locations = resp.data.locations;

          for (let i = 0; i < self.$store.state.locations.length; i++) {
            var loc = self.$store.state.locations[i];

            if (!loc.billing_sepa || loc.billing_sepa != "y") {
              loc.billing_sepa = "n"
            }

            loc.account_tags_sort = loc.account_tags && loc.account_tags.length
              ? loc.account_tags.join(', ')
              : '';

            // Sort key for the Flutter adoption column: adopted rows sort by their
            // first-seen timestamp, not-adopted rows sort to the bottom (empty string).
            loc.flutter_adopted_sort = loc.flutter_app_first_seen_at || '';
          }
        }
      }).catch(() => {
        localStorage.removeItem("token");
        self.$router.push({ name: "login" });
      });
    }
  },
  filters: {
    uppercase: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    },
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
  mounted() {
    this.reload();
  },
};
</script>

<style scoped>
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
  color: #9c9fa6;
}

.loading-container i {
  font-size: 40px;
  margin-bottom: 12px;
}

.preset-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  margin-bottom: 12px;
}

.preset-label {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #9c9fa6;
  margin-right: 4px;
}

.filter-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  margin-bottom: 20px;
}

.chip-notes {
  margin: -8px 0 18px 0;
}

.chip-note {
  font-size: 12px;
  line-height: 1.5;
  color: #6c7293;
  margin-bottom: 4px;
  max-width: 900px;
}

.filter-chips .tag-select {
  width: auto;
  min-width: 140px;
}

.sortable-th {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}

.sortable-th:hover {
  color: #2563eb;
}

.sort-icon {
  font-size: 11px;
  margin-left: 4px;
}

.sort-icon-inactive {
  opacity: 0.3;
}

.empty-state {
  text-align: center;
  padding: 40px 0;
  color: #9c9fa6;
}

.empty-state i {
  font-size: 48px;
  display: block;
  margin-bottom: 10px;
}

.link-col {
  color: #2563eb;
  text-decoration: none;
}

.link-col:hover {
  color: #1d4ed8;
}
</style>